import {
  Box,
  Button,
  Container,
  Grid2,
  List,
  ListItemButton,
  ListItemText,
  Typography
} from '@mui/material';

export default function Footer() {
  return (
    <Box
      sx={{
        mt: 10,
        py: 10,
      }}
    >
      <Container maxWidth="md">
        <Grid2 container spacing={{ sm: 1, xs: 2 }}>

          <Grid2 size={{ sm: 6, xs: 12 }}>
            <Grid2 container spacing={{ sm: 1, xs: 2 }}>
              <Grid2>
                <Button size="small" color="inherit" target="_blank" href="https://help.opengolfsim.com/">Support</Button>
              </Grid2>
              <Grid2>
                <Button size="small" color="inherit" target="_blank" href="https://help.opengolfsim.com/terms">Terms of Service</Button>
              </Grid2>
              <Grid2>
                <Button size="small" color="inherit" target="_blank" href="https://help.opengolfsim.com/privacy">Privacy Policy</Button>
              </Grid2>
            </Grid2>

            <Box sx={{ my: 3 }}>
              <Typography variant="body2" component="span">&copy; 2025 OpenGolfSim LLC All Rights Reserved</Typography>
            </Box>

          </Grid2>
        </Grid2>


      </Container>
    </Box>
  )
}